import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  l,
  f,
  BoxC,
  IptC,
  LblC,
  GridC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';
import * as icm from './icm';
import * as ihd from './ihd';

export const N = (pz: {
  sPz: ht.dz,
  boxStlz: ht.dz,
  frcUdt: () => void,
  cz: {
    i1zz: ht.dz,
    i17rs: ht.ls,
    onChgAsync: () => void,
  }
}) => {

//hf.l(`icvI1zS11Co3c 34: here`);
  return (
    cr.c(BoxC.N, {
      key: 'Iccv23b4c.root',
      boxStlz: {
        ... a('dw/f'),
        ... pz.boxStlz
      },
      oClds: [

        cr.c(GridC.N, {
          key: -30,
          abtType: 'nolineCmnz',
          lineCs: [
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      boxStlz: a('sc/yw3'),
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/18'),
                        textz: {
                          pfx: '団体の減免情報：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'pcr',
                              ls: ihd.f('i18raa100i').ls,
                              vle: pz.cz.i1zz?.i18rz?.i18raa100i ?? -1,
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '減免率：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: 
                                hf.i(pz.sPz.crt.phs, ['crt', 'udt']) &&
                                pz.cz.i1zz.i1zrz.i1zrs1100i != 90,
                              iptType: 'pcr',
                              ls: ihd.f('i1z3t1100i').ls,
                              vle: pz.cz.i1zz?.i1z3z.i1z3t1100i,
                              onChg: ( _dz: ht.dz ) => {
                                pz.cz.i1zz.i1z3z.i1z3t1100i = _dz.key;
/*
                                const _dz2 = icm.grtI1z3z({
                                  i1zz: pz.cz.i1zz,
                                  i17rs: pz.cz.i17rs,
                                });
                                hf.udtDz(pz.cz.i1zz?.i1z3z, _dz2);
                                //_udtI1z3z();
*/
                                icm.udtI1z3z({
                                  i1zz: pz.cz.i1zz,
                                  i17rs: pz.cz.i17rs,
                                });
                                pz.frcUdt();
                              }
                            }
                          })

                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        boxStlz: a('dw/16'),
                        textz: {
                          pfx: '任意減免金額：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(TextC.N, {
                            key: -10,
                            textz: {
                              pfx: '▲',
                            }
                          }),
                          cr.c(IptC.S, {
                            key: -20,
                            iptStlz: a('ta/r'),
                            cz: {
                              bEdit: 
                                hf.i(pz.sPz.crt.phs, ['crt', 'udt']) && 
                                pz.cz.i1zz?.i1z3z.i1z3t1100i == 999 &&
                                pz.cz.i1zz.i1zrz.i1zrs1100i != 90,
                              iptType: 'text',                              
                              vle: pz.cz.i1zz?.i1z3z.i1z3m2100i,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1z3z.i1z3m2100i = Number(_s);
/*
                                const _dz = icm.grtI1z3z({
                                  i1zz: pz.cz.i1zz,
                                  i17rs: pz.cz.i17rs,
                                });
                                hf.udtDz(pz.cz.i1zz?.i1z3z, _dz);
*/
                                icm.udtI1z3z({
                                  i1zz: pz.cz.i1zz,
                                  i17rs: pz.cz.i17rs,
                                });
                                //_udtI1z3z();
                                pz.frcUdt();
                              }
                            }
                          }),
                          cr.c(TextC.N, {
                            key: -30,
                            abtType: 'bsdCmnz',
                            textz: {
                              pfx: '円',
                            },
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`bc/gn7 bwb/1 mb/1 pb/1`),
              cellCs: [
                {
                  boxStlz: a(`bc/t bwt/1 pt/1.0`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/18'),
                        textz: {
                          pfx: '減免理由：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']) && pz.cz.i1zz?.i1z3z.i1z3t1100i > 0,
                              iptType: 'pcr',
                              ls: ihd.f('i1z3t2100i').ls,
                              vle: pz.cz.i1zz?.i1z3z.i1z3t2100i,
                              onChg: ( _dz: ht.dz ) => {
                                pz.cz.i1zz.i1z3z.i1z3t2100i = _dz.key;
                              }
                            }
                          })

                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, ['crt', 'udt']) && pz.cz.i1zz?.i1z3z.i1z3t1100i > 0 ?
                          {
                            abtType: 'omtRqrCmnz',
                          }
                        : null,
                    }),
                  ]
                },
                {
                  oClds: [
                  ]
                },
                {
//                  boxStlz: a(`bc/gn7 bwt/1 pt/0.5`),
                  boxStlz: a(`bc/gn7 bwt/1 pt/1.0`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      boxStlz: a('sc/yw3'),
                      lblCz: {
                        boxStlz: a('dw/16'),
                        textz: {
                          pfx: '減免後の金額：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            iptStlz: a('tb ta/r tc/rd5'),
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1z3z.i1z3m1110i - pz.cz.i1zz?.i1z3z.i1z3m2100i,
                              grtPfx: (_s: ht.s) => hf.cvtCmm(hf.n(_s)),
                            }
                          }),
                          cr.c(TextC.N, {
                            key: -20,
                            abtType: 'bsdCmnz',
                            textz: {
                              pfx: '円',
                            },
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
/*
            {
              boxStlz: a(`bc/gn7 bwb/1 mb/1 pb/1`),
              cellCs: [
                {
                  boxStlz: a(`f/2`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/18'),
                        textz: {
                          pfx: 'その他支払内容：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1z3z.i1z3a1100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1z3z.i1z3a1100s = _s;
                              }
                            }
                          })

                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        textz: {
                          pfx: '金額',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            iptStlz: a('ta/r tb'),
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1z3z.i1z3m3100i,
                              grtPfx: (_s: ht.s) => hf.cnvCmm(hf.n(_s)),
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1z3z.i1z3m3100i = Number(_s);
                                const _dz = icm.grtI1z3z({
                                  i1z1s: pz.cz.i1zz?.i1z1s,
                                  i1z2s: pz.cz.i1zz?.i1z2s,
                                  i1z3z: pz.cz.i1zz?.i1z3z,
                                });
                                hf.udtDz(pz.cz.i1zz?.i1z3z, _dz);
                                _udtI1z3z();
                              }
                            }
                          }),
                          cr.c(TextC.N, {
                            key: -20,
                            abtType: 'bsdCmnz',
                            textz: {
                              pfx: '円',
                            },
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              cellCs: [
                {
                  boxStlz: a('f/2'),
                  oClds: [
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      boxStlz: a('pl/2 sc/rd5'),
                      lblCz: {
                        textz: {
                          pfx: '支払額合計：',
                          stlz: a('tc/lt1'),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            iptStlz: a(`ta/r tc/lt1`),
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1z3z.i1z3m4100i,
                              grtPfx: (_s: ht.s) => hf.cnvCmm(hf.n(_s)),
                            }
                          }),
                          cr.c(TextC.N, {
                            key: -20,
                            abtType: 'bsdCmnz',
                            textz: {
                              pfx: '円',
                              stlz: a('ta/r tb tc/lt1'),
                            },
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '利用目的',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1zrz.i1zra4100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz.i1zra4100s = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: {
                        abtType: 'omtRqrCmnz',
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                  ]
                },
              ]
            },
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '備考',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1zrz._ctn,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz._ctn = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '優先利用',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i1zrt1100i').ls,
                              vle: pz.cz.i1zz?.i1zrz.i1zrt1100i,
                              onChg: ( _dz: ht.dz ) => {
                                pz.cz.i1zz.i1zrz.i1zrt1100i = _dz.key;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        textz: {
                          pfx: '内部メモ',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1zrz.i1zra5100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz.i1zra5100s = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '予約状況',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'pcr',
                              ls: 
                                pz.sPz.crt.ctt == 'r' ?
                                  ihd.f('i1zrs1100i').ls
                                : pz.sPz.crt.ctt == 'e' ?
                                  ihd.f('i1zrs2100i').ls
                                : [],
                              vle: 
                                pz.sPz.crt.ctt == 'r' ?
                                  pz.cz.i1zz?.i1zrz.i1zrs1100i
                                : pz.sPz.crt.ctt == 'e' ?
                                  pz.cz.i1zz?.i1zrz.i1zrs2100i
                                : -1,
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '受領日',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'dtm',
                              vle: pz.cz.i1zz?.i1z3z.i1z3d2100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1z3z.i1z3d2100s = _s;
                                hf.udtDz(pz.cz.i1zz?.i1z3z, icm.grtI1z3z({
                                  i1z1s: pz.cz.i1zz?.i1z1s,
                                  i1z2s: pz.cz.i1zz?.i1z2s,
                                  i1z3z: pz.cz.i1zz?.i1z3z,
                                }))
                                if ( pz.cz.i1zz?.i1z3z.i1z3s1100i == 40 ) {
                                  pz.cz.i1zz.i1zrz.i1zrs1100i = 90;
                                }
                                _udtI1z3z();
                              }
                            }
                          })

                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        textz: {
                          pfx: '支払方法',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                            bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i1z3t3100i').ls,
                              vle: pz.cz.i1zz?.i1z3z.i1z3t3100i,
                              onChg: ( _dz: ht.dz ) => {
                                pz.cz.i1zz.i1z3z.i1z3t3100i = _dz.key;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
*/
          ]
        })

      ]
    })
  );
};
